// GENERATED by ax-design-system/build-tokens.mjs — 직접 수정 금지. tokens.json 을 고치고 재생성할 것.
// source-hash: f73444384392

/** 토큰 경로 → CSS 변수 참조. 인라인 스타일/차트 등 클래스로 표현 불가한 곳에서만 사용 */
export const tokenVar = {
  "breakpoint.2xl": 'var(--breakpoint-2xl)',
  "breakpoint.lg": 'var(--breakpoint-lg)',
  "breakpoint.md": 'var(--breakpoint-md)',
  "breakpoint.sm": 'var(--breakpoint-sm)',
  "breakpoint.xl": 'var(--breakpoint-xl)',
  "color.bg.canvas": 'var(--color-bg-canvas)',
  "color.bg.danger": 'var(--color-bg-danger)',
  "color.bg.danger-hover": 'var(--color-bg-danger-hover)',
  "color.bg.danger-pressed": 'var(--color-bg-danger-pressed)',
  "color.bg.danger-subtle": 'var(--color-bg-danger-subtle)',
  "color.bg.danger-subtle-hover": 'var(--color-bg-danger-subtle-hover)',
  "color.bg.disabled": 'var(--color-bg-disabled)',
  "color.bg.hover": 'var(--color-bg-hover)',
  "color.bg.info": 'var(--color-bg-info)',
  "color.bg.info-hover": 'var(--color-bg-info-hover)',
  "color.bg.info-pressed": 'var(--color-bg-info-pressed)',
  "color.bg.info-subtle": 'var(--color-bg-info-subtle)',
  "color.bg.info-subtle-hover": 'var(--color-bg-info-subtle-hover)',
  "color.bg.inverse": 'var(--color-bg-inverse)',
  "color.bg.manager": 'var(--color-bg-manager)',
  "color.bg.memo": 'var(--color-bg-memo)',
  "color.bg.muted": 'var(--color-bg-muted)',
  "color.bg.neutral": 'var(--color-bg-neutral)',
  "color.bg.overlay": 'var(--color-bg-overlay)',
  "color.bg.pressed": 'var(--color-bg-pressed)',
  "color.bg.primary": 'var(--color-bg-primary)',
  "color.bg.primary-hover": 'var(--color-bg-primary-hover)',
  "color.bg.primary-pressed": 'var(--color-bg-primary-pressed)',
  "color.bg.primary-subtle": 'var(--color-bg-primary-subtle)',
  "color.bg.primary-subtle-hover": 'var(--color-bg-primary-subtle-hover)',
  "color.bg.row-hover": 'var(--color-bg-row-hover)',
  "color.bg.secondary": 'var(--color-bg-secondary)',
  "color.bg.secondary-hover": 'var(--color-bg-secondary-hover)',
  "color.bg.secondary-pressed": 'var(--color-bg-secondary-pressed)',
  "color.bg.secondary-subtle": 'var(--color-bg-secondary-subtle)',
  "color.bg.secondary-subtle-hover": 'var(--color-bg-secondary-subtle-hover)',
  "color.bg.status-exit": 'var(--color-bg-status-exit)',
  "color.bg.status-impairment": 'var(--color-bg-status-impairment)',
  "color.bg.status-partial-exit": 'var(--color-bg-status-partial-exit)',
  "color.bg.status-shutdown": 'var(--color-bg-status-shutdown)',
  "color.bg.subtle": 'var(--color-bg-subtle)',
  "color.bg.success": 'var(--color-bg-success)',
  "color.bg.success-hover": 'var(--color-bg-success-hover)',
  "color.bg.success-pressed": 'var(--color-bg-success-pressed)',
  "color.bg.success-subtle": 'var(--color-bg-success-subtle)',
  "color.bg.success-subtle-hover": 'var(--color-bg-success-subtle-hover)',
  "color.bg.surface": 'var(--color-bg-surface)',
  "color.bg.tag-filled": 'var(--color-bg-tag-filled)',
  "color.bg.warning": 'var(--color-bg-warning)',
  "color.bg.warning-hover": 'var(--color-bg-warning-hover)',
  "color.bg.warning-pressed": 'var(--color-bg-warning-pressed)',
  "color.bg.warning-subtle": 'var(--color-bg-warning-subtle)',
  "color.bg.warning-subtle-hover": 'var(--color-bg-warning-subtle-hover)',
  "color.black": 'var(--color-black)',
  "color.black-alpha.50": 'var(--color-black-alpha-50)',
  "color.black-alpha.70": 'var(--color-black-alpha-70)',
  "color.border.control": 'var(--color-border-control)',
  "color.border.danger": 'var(--color-border-danger)',
  "color.border.default": 'var(--color-border-default)',
  "color.border.focus": 'var(--color-border-focus)',
  "color.border.info": 'var(--color-border-info)',
  "color.border.input": 'var(--color-border-input)',
  "color.border.input-focus": 'var(--color-border-input-focus)',
  "color.border.primary": 'var(--color-border-primary)',
  "color.border.secondary": 'var(--color-border-secondary)',
  "color.border.subtle": 'var(--color-border-subtle)',
  "color.border.success": 'var(--color-border-success)',
  "color.border.warning": 'var(--color-border-warning)',
  "color.brand.primary": 'var(--color-brand-primary)',
  "color.brand.secondary": 'var(--color-brand-secondary)',
  "color.danger.50": 'var(--color-danger-50)',
  "color.danger.100": 'var(--color-danger-100)',
  "color.danger.200": 'var(--color-danger-200)',
  "color.danger.300": 'var(--color-danger-300)',
  "color.danger.400": 'var(--color-danger-400)',
  "color.danger.500": 'var(--color-danger-500)',
  "color.danger.600": 'var(--color-danger-600)',
  "color.danger.700": 'var(--color-danger-700)',
  "color.danger.800": 'var(--color-danger-800)',
  "color.danger.900": 'var(--color-danger-900)',
  "color.danger.950": 'var(--color-danger-950)',
  "color.dataviz.axis": 'var(--color-dataviz-axis)',
  "color.dataviz.baseline": 'var(--color-dataviz-baseline)',
  "color.dataviz.divider": 'var(--color-dataviz-divider)',
  "color.dataviz.gap": 'var(--color-dataviz-gap)',
  "color.dataviz.grade.1": 'var(--color-dataviz-grade-1)',
  "color.dataviz.grade.2": 'var(--color-dataviz-grade-2)',
  "color.dataviz.grade.3": 'var(--color-dataviz-grade-3)',
  "color.dataviz.grade.4": 'var(--color-dataviz-grade-4)',
  "color.dataviz.grade.none": 'var(--color-dataviz-grade-none)',
  "color.dataviz.grid": 'var(--color-dataviz-grid)',
  "color.dataviz.legend": 'var(--color-dataviz-legend)',
  "color.dataviz.negative.1": 'var(--color-dataviz-negative-1)',
  "color.dataviz.negative.2": 'var(--color-dataviz-negative-2)',
  "color.dataviz.negative.3": 'var(--color-dataviz-negative-3)',
  "color.dataviz.negative.4": 'var(--color-dataviz-negative-4)',
  "color.dataviz.negative.5": 'var(--color-dataviz-negative-5)',
  "color.dataviz.negative.6": 'var(--color-dataviz-negative-6)',
  "color.dataviz.negative.7": 'var(--color-dataviz-negative-7)',
  "color.dataviz.negative.8": 'var(--color-dataviz-negative-8)',
  "color.dataviz.negative.9": 'var(--color-dataviz-negative-9)',
  "color.dataviz.negative.10": 'var(--color-dataviz-negative-10)',
  "color.dataviz.on-dark": 'var(--color-dataviz-on-dark)',
  "color.dataviz.on-light": 'var(--color-dataviz-on-light)',
  "color.dataviz.on-tooltip": 'var(--color-dataviz-on-tooltip)',
  "color.dataviz.positive.1": 'var(--color-dataviz-positive-1)',
  "color.dataviz.positive.2": 'var(--color-dataviz-positive-2)',
  "color.dataviz.positive.3": 'var(--color-dataviz-positive-3)',
  "color.dataviz.positive.4": 'var(--color-dataviz-positive-4)',
  "color.dataviz.positive.5": 'var(--color-dataviz-positive-5)',
  "color.dataviz.positive.6": 'var(--color-dataviz-positive-6)',
  "color.dataviz.positive.7": 'var(--color-dataviz-positive-7)',
  "color.dataviz.positive.8": 'var(--color-dataviz-positive-8)',
  "color.dataviz.positive.9": 'var(--color-dataviz-positive-9)',
  "color.dataviz.positive.10": 'var(--color-dataviz-positive-10)',
  "color.dataviz.series.1": 'var(--color-dataviz-series-1)',
  "color.dataviz.series.2": 'var(--color-dataviz-series-2)',
  "color.dataviz.series.3": 'var(--color-dataviz-series-3)',
  "color.dataviz.series.4": 'var(--color-dataviz-series-4)',
  "color.dataviz.series.5": 'var(--color-dataviz-series-5)',
  "color.dataviz.series.6": 'var(--color-dataviz-series-6)',
  "color.dataviz.series.7": 'var(--color-dataviz-series-7)',
  "color.dataviz.series.8": 'var(--color-dataviz-series-8)',
  "color.dataviz.series.9": 'var(--color-dataviz-series-9)',
  "color.dataviz.series.10": 'var(--color-dataviz-series-10)',
  "color.dataviz.tooltip": 'var(--color-dataviz-tooltip)',
  "color.dataviz.tooltip-divider": 'var(--color-dataviz-tooltip-divider)',
  "color.dataviz.track": 'var(--color-dataviz-track)',
  "color.dataviz.trend.down": 'var(--color-dataviz-trend-down)',
  "color.dataviz.trend.down-text": 'var(--color-dataviz-trend-down-text)',
  "color.dataviz.trend.flat": 'var(--color-dataviz-trend-flat)',
  "color.dataviz.trend.up": 'var(--color-dataviz-trend-up)',
  "color.dataviz.trend.up-text": 'var(--color-dataviz-trend-up-text)',
  "color.dataviz.value": 'var(--color-dataviz-value)',
  "color.fg.danger": 'var(--color-fg-danger)',
  "color.fg.default": 'var(--color-fg-default)',
  "color.fg.disabled": 'var(--color-fg-disabled)',
  "color.fg.info": 'var(--color-fg-info)',
  "color.fg.inverse": 'var(--color-fg-inverse)',
  "color.fg.metric-primary": 'var(--color-fg-metric-primary)',
  "color.fg.muted": 'var(--color-fg-muted)',
  "color.fg.placeholder": 'var(--color-fg-placeholder)',
  "color.fg.primary": 'var(--color-fg-primary)',
  "color.fg.secondary": 'var(--color-fg-secondary)',
  "color.fg.success": 'var(--color-fg-success)',
  "color.fg.warning": 'var(--color-fg-warning)',
  "color.info.50": 'var(--color-info-50)',
  "color.info.100": 'var(--color-info-100)',
  "color.info.200": 'var(--color-info-200)',
  "color.info.300": 'var(--color-info-300)',
  "color.info.400": 'var(--color-info-400)',
  "color.info.500": 'var(--color-info-500)',
  "color.info.600": 'var(--color-info-600)',
  "color.info.700": 'var(--color-info-700)',
  "color.info.800": 'var(--color-info-800)',
  "color.info.900": 'var(--color-info-900)',
  "color.info.950": 'var(--color-info-950)',
  "color.neutral.50": 'var(--color-neutral-50)',
  "color.neutral.100": 'var(--color-neutral-100)',
  "color.neutral.200": 'var(--color-neutral-200)',
  "color.neutral.300": 'var(--color-neutral-300)',
  "color.neutral.400": 'var(--color-neutral-400)',
  "color.neutral.500": 'var(--color-neutral-500)',
  "color.neutral.600": 'var(--color-neutral-600)',
  "color.neutral.700": 'var(--color-neutral-700)',
  "color.neutral.800": 'var(--color-neutral-800)',
  "color.neutral.900": 'var(--color-neutral-900)',
  "color.neutral.950": 'var(--color-neutral-950)',
  "color.on.danger": 'var(--color-on-danger)',
  "color.on.info": 'var(--color-on-info)',
  "color.on.neutral": 'var(--color-on-neutral)',
  "color.on.primary": 'var(--color-on-primary)',
  "color.on.secondary": 'var(--color-on-secondary)',
  "color.on.status": 'var(--color-on-status)',
  "color.on.success": 'var(--color-on-success)',
  "color.on.warning": 'var(--color-on-warning)',
  "color.primary.50": 'var(--color-primary-50)',
  "color.primary.100": 'var(--color-primary-100)',
  "color.primary.200": 'var(--color-primary-200)',
  "color.primary.300": 'var(--color-primary-300)',
  "color.primary.400": 'var(--color-primary-400)',
  "color.primary.500": 'var(--color-primary-500)',
  "color.primary.600": 'var(--color-primary-600)',
  "color.primary.700": 'var(--color-primary-700)',
  "color.primary.800": 'var(--color-primary-800)',
  "color.primary.900": 'var(--color-primary-900)',
  "color.primary.950": 'var(--color-primary-950)',
  "color.raw.gray-shadow": 'var(--color-raw-gray-shadow)',
  "color.raw.green-50": 'var(--color-raw-green-50)',
  "color.raw.mint-50": 'var(--color-raw-mint-50)',
  "color.raw.red-soft": 'var(--color-raw-red-soft)',
  "color.secondary.50": 'var(--color-secondary-50)',
  "color.secondary.100": 'var(--color-secondary-100)',
  "color.secondary.200": 'var(--color-secondary-200)',
  "color.secondary.300": 'var(--color-secondary-300)',
  "color.secondary.400": 'var(--color-secondary-400)',
  "color.secondary.500": 'var(--color-secondary-500)',
  "color.secondary.600": 'var(--color-secondary-600)',
  "color.secondary.700": 'var(--color-secondary-700)',
  "color.secondary.800": 'var(--color-secondary-800)',
  "color.secondary.900": 'var(--color-secondary-900)',
  "color.secondary.950": 'var(--color-secondary-950)',
  "color.success.50": 'var(--color-success-50)',
  "color.success.100": 'var(--color-success-100)',
  "color.success.200": 'var(--color-success-200)',
  "color.success.300": 'var(--color-success-300)',
  "color.success.400": 'var(--color-success-400)',
  "color.success.500": 'var(--color-success-500)',
  "color.success.600": 'var(--color-success-600)',
  "color.success.700": 'var(--color-success-700)',
  "color.success.800": 'var(--color-success-800)',
  "color.success.900": 'var(--color-success-900)',
  "color.success.950": 'var(--color-success-950)',
  "color.warning.50": 'var(--color-warning-50)',
  "color.warning.100": 'var(--color-warning-100)',
  "color.warning.200": 'var(--color-warning-200)',
  "color.warning.300": 'var(--color-warning-300)',
  "color.warning.400": 'var(--color-warning-400)',
  "color.warning.500": 'var(--color-warning-500)',
  "color.warning.600": 'var(--color-warning-600)',
  "color.warning.700": 'var(--color-warning-700)',
  "color.warning.800": 'var(--color-warning-800)',
  "color.warning.900": 'var(--color-warning-900)',
  "color.warning.950": 'var(--color-warning-950)',
  "color.white": 'var(--color-white)',
  "container.content": 'var(--container-content)',
  "font.mono": 'var(--font-mono)',
  "font.sans": 'var(--font-sans)',
  "fontWeight.bold": 'var(--font-weight-bold)',
  "fontWeight.medium": 'var(--font-weight-medium)',
  "fontWeight.regular": 'var(--font-weight-regular)',
  "fontWeight.semibold": 'var(--font-weight-semibold)',
  "motion.duration.base": 'var(--motion-duration-base)',
  "motion.duration.fast": 'var(--motion-duration-fast)',
  "motion.duration.instant": 'var(--motion-duration-instant)',
  "motion.duration.slow": 'var(--motion-duration-slow)',
  "motion.duration.slower": 'var(--motion-duration-slower)',
  "motion.easing.accelerate": 'var(--motion-easing-accelerate)',
  "motion.easing.decelerate": 'var(--motion-easing-decelerate)',
  "motion.easing.standard": 'var(--motion-easing-standard)',
  "opacity.disabled": 'var(--opacity-disabled)',
  "opacity.loading": 'var(--opacity-loading)',
  "opacity.muted": 'var(--opacity-muted)',
  "radius.2xl": 'var(--radius-2xl)',
  "radius.3xl": 'var(--radius-3xl)',
  "radius.4xl": 'var(--radius-4xl)',
  "radius.full": 'var(--radius-full)',
  "radius.lg": 'var(--radius-lg)',
  "radius.md": 'var(--radius-md)',
  "radius.none": 'var(--radius-none)',
  "radius.sm": 'var(--radius-sm)',
  "radius.xl": 'var(--radius-xl)',
  "radius.xs": 'var(--radius-xs)',
  "elevation.card": 'var(--shadow-card)',
  "elevation.card-accent": 'var(--shadow-card-accent)',
  "elevation.card-strong": 'var(--shadow-card-strong)',
  "elevation.chip": 'var(--shadow-chip)',
  "elevation.drawer": 'var(--shadow-drawer)',
  "elevation.drop": 'var(--shadow-drop)',
  "elevation.dropdown": 'var(--shadow-dropdown)',
  "elevation.halo": 'var(--shadow-halo)',
  "elevation.modal": 'var(--shadow-modal)',
  "elevation.popover": 'var(--shadow-popover)',
  "elevation.subtle": 'var(--shadow-subtle)',
  "size.button.2xl": 'var(--size-button-2xl)',
  "size.button.lg": 'var(--size-button-lg)',
  "size.button.md": 'var(--size-button-md)',
  "size.button.sm": 'var(--size-button-sm)',
  "size.button.xl": 'var(--size-button-xl)',
  "size.button.xs": 'var(--size-button-xs)',
  "size.chart.stacked-bar": 'var(--size-chart-stacked-bar)',
  "size.chart.time-series": 'var(--size-chart-time-series)',
  "size.chart.tooltip": 'var(--size-chart-tooltip)',
  "size.chart.tooltip-rows": 'var(--size-chart-tooltip-rows)',
  "size.chart.treemap": 'var(--size-chart-treemap)',
  "size.chart.treemap-empty": 'var(--size-chart-treemap-empty)',
  "size.container.app": 'var(--size-container-app)',
  "size.container.drawer": 'var(--size-container-drawer)',
  "size.container.form": 'var(--size-container-form)',
  "size.container.page": 'var(--size-container-page)',
  "size.container.table": 'var(--size-container-table)',
  "size.container.wide": 'var(--size-container-wide)',
  "size.control.2xs": 'var(--size-control-2xs)',
  "size.control.lg": 'var(--size-control-lg)',
  "size.control.md": 'var(--size-control-md)',
  "size.control.sm": 'var(--size-control-sm)',
  "size.control.xs": 'var(--size-control-xs)',
  "size.dialog.alert": 'var(--size-dialog-alert)',
  "size.dialog.lg": 'var(--size-dialog-lg)',
  "size.dialog.md": 'var(--size-dialog-md)',
  "size.dialog.sm": 'var(--size-dialog-sm)',
  "size.dialog.xs": 'var(--size-dialog-xs)',
  "size.editor": 'var(--size-editor)',
  "size.icon-circle": 'var(--size-icon-circle)',
  "size.icon.lg": 'var(--size-icon-lg)',
  "size.icon.md": 'var(--size-icon-md)',
  "size.icon.sm": 'var(--size-icon-sm)',
  "size.icon.xl": 'var(--size-icon-xl)',
  "size.icon.xs": 'var(--size-icon-xs)',
  "size.input.lg": 'var(--size-input-lg)',
  "size.input.md": 'var(--size-input-md)',
  "size.input.sm": 'var(--size-input-sm)',
  "size.input.xl": 'var(--size-input-xl)',
  "size.label": 'var(--size-label)',
  "size.list": 'var(--size-list)',
  "size.listbox-max": 'var(--size-listbox-max)',
  "size.row": 'var(--size-row)',
  "size.section": 'var(--size-section)',
  "size.skeleton.40": 'var(--size-skeleton-40)',
  "size.skeleton.42": 'var(--size-skeleton-42)',
  "size.skeleton.56": 'var(--size-skeleton-56)',
  "size.skeleton.60": 'var(--size-skeleton-60)',
  "size.skeleton.72": 'var(--size-skeleton-72)',
  "size.skeleton.80": 'var(--size-skeleton-80)',
  "size.skeleton.84": 'var(--size-skeleton-84)',
  "size.skeleton.92": 'var(--size-skeleton-92)',
  "size.skeleton.96": 'var(--size-skeleton-96)',
  "size.skeleton.100": 'var(--size-skeleton-100)',
  "size.skeleton.114": 'var(--size-skeleton-114)',
  "size.skeleton.116": 'var(--size-skeleton-116)',
  "size.skeleton.119": 'var(--size-skeleton-119)',
  "size.skeleton.120": 'var(--size-skeleton-120)',
  "size.skeleton.128": 'var(--size-skeleton-128)',
  "size.skeleton.134": 'var(--size-skeleton-134)',
  "size.skeleton.140": 'var(--size-skeleton-140)',
  "size.skeleton.160": 'var(--size-skeleton-160)',
  "size.skeleton.180": 'var(--size-skeleton-180)',
  "size.skeleton.200": 'var(--size-skeleton-200)',
  "size.skeleton.220": 'var(--size-skeleton-220)',
  "size.skeleton.235": 'var(--size-skeleton-235)',
  "size.skeleton.240": 'var(--size-skeleton-240)',
  "size.skeleton.300": 'var(--size-skeleton-300)',
  "size.skeleton.320": 'var(--size-skeleton-320)',
  "size.skeleton.392": 'var(--size-skeleton-392)',
  "size.spacer": 'var(--size-spacer)',
  "size.table-row": 'var(--size-table-row)',
  "size.textarea": 'var(--size-textarea)',
  "size.touch": 'var(--size-touch)',
  "space.0": 'var(--spacing-0)',
  "space.1": 'var(--spacing-1)',
  "space.2": 'var(--spacing-2)',
  "space.2-5": 'var(--spacing-2-5)',
  "space.3": 'var(--spacing-3)',
  "space.4": 'var(--spacing-4)',
  "space.5": 'var(--spacing-5)',
  "space.6": 'var(--spacing-6)',
  "space.8": 'var(--spacing-8)',
  "space.10": 'var(--spacing-10)',
  "space.12": 'var(--spacing-12)',
  "space.16": 'var(--spacing-16)',
  "space.20": 'var(--spacing-20)',
  "space.24": 'var(--spacing-24)',
  "space.gutter": 'var(--spacing-gutter)',
  "typography.body": 'var(--text-body)',
  "typography.body-lg": 'var(--text-body-lg)',
  "typography.body-lg-medium": 'var(--text-body-lg-medium)',
  "typography.body-medium": 'var(--text-body-medium)',
  "typography.body-sm": 'var(--text-body-sm)',
  "typography.body-sm-strong": 'var(--text-body-sm-strong)',
  "typography.body-strong": 'var(--text-body-strong)',
  "typography.caption": 'var(--text-caption)',
  "typography.caption-sm": 'var(--text-caption-sm)',
  "typography.caption-strong": 'var(--text-caption-strong)',
  "typography.display": 'var(--text-display)',
  "typography.heading-1": 'var(--text-heading-1)',
  "typography.heading-2": 'var(--text-heading-2)',
  "typography.heading-3": 'var(--text-heading-3)',
  "typography.heading-4": 'var(--text-heading-4)',
  "typography.label": 'var(--text-label)',
  "typography.label-sm": 'var(--text-label-sm)',
  "typography.micro": 'var(--text-micro)',
  "typography.micro-strong": 'var(--text-micro-strong)',
  "typography.title": 'var(--text-title)',
  "z.base": 'var(--z-base)',
  "z.dropdown": 'var(--z-dropdown)',
  "z.modal": 'var(--z-modal)',
  "z.overlay": 'var(--z-overlay)',
  "z.sticky": 'var(--z-sticky)',
  "z.sticky-content": 'var(--z-sticky-content)',
  "z.toast": 'var(--z-toast)',
  "z.tooltip": 'var(--z-tooltip)',
} as const;

export type TokenPath = keyof typeof tokenVar;

export type ColorToken = 'bg-canvas' | 'bg-danger' | 'bg-danger-hover' | 'bg-danger-pressed' | 'bg-danger-subtle' | 'bg-danger-subtle-hover' | 'bg-disabled' | 'bg-hover' | 'bg-info' | 'bg-info-hover' | 'bg-info-pressed' | 'bg-info-subtle' | 'bg-info-subtle-hover' | 'bg-inverse' | 'bg-manager' | 'bg-memo' | 'bg-muted' | 'bg-neutral' | 'bg-overlay' | 'bg-pressed' | 'bg-primary' | 'bg-primary-hover' | 'bg-primary-pressed' | 'bg-primary-subtle' | 'bg-primary-subtle-hover' | 'bg-row-hover' | 'bg-secondary' | 'bg-secondary-hover' | 'bg-secondary-pressed' | 'bg-secondary-subtle' | 'bg-secondary-subtle-hover' | 'bg-status-exit' | 'bg-status-impairment' | 'bg-status-partial-exit' | 'bg-status-shutdown' | 'bg-subtle' | 'bg-success' | 'bg-success-hover' | 'bg-success-pressed' | 'bg-success-subtle' | 'bg-success-subtle-hover' | 'bg-surface' | 'bg-tag-filled' | 'bg-warning' | 'bg-warning-hover' | 'bg-warning-pressed' | 'bg-warning-subtle' | 'bg-warning-subtle-hover' | 'black' | 'black-alpha-50' | 'black-alpha-70' | 'border-control' | 'border-danger' | 'border-default' | 'border-focus' | 'border-info' | 'border-input' | 'border-input-focus' | 'border-primary' | 'border-secondary' | 'border-subtle' | 'border-success' | 'border-warning' | 'brand-primary' | 'brand-secondary' | 'danger-50' | 'danger-100' | 'danger-200' | 'danger-300' | 'danger-400' | 'danger-500' | 'danger-600' | 'danger-700' | 'danger-800' | 'danger-900' | 'danger-950' | 'dataviz-axis' | 'dataviz-baseline' | 'dataviz-divider' | 'dataviz-gap' | 'dataviz-grade-1' | 'dataviz-grade-2' | 'dataviz-grade-3' | 'dataviz-grade-4' | 'dataviz-grade-none' | 'dataviz-grid' | 'dataviz-legend' | 'dataviz-negative-1' | 'dataviz-negative-2' | 'dataviz-negative-3' | 'dataviz-negative-4' | 'dataviz-negative-5' | 'dataviz-negative-6' | 'dataviz-negative-7' | 'dataviz-negative-8' | 'dataviz-negative-9' | 'dataviz-negative-10' | 'dataviz-on-dark' | 'dataviz-on-light' | 'dataviz-on-tooltip' | 'dataviz-positive-1' | 'dataviz-positive-2' | 'dataviz-positive-3' | 'dataviz-positive-4' | 'dataviz-positive-5' | 'dataviz-positive-6' | 'dataviz-positive-7' | 'dataviz-positive-8' | 'dataviz-positive-9' | 'dataviz-positive-10' | 'dataviz-series-1' | 'dataviz-series-2' | 'dataviz-series-3' | 'dataviz-series-4' | 'dataviz-series-5' | 'dataviz-series-6' | 'dataviz-series-7' | 'dataviz-series-8' | 'dataviz-series-9' | 'dataviz-series-10' | 'dataviz-tooltip' | 'dataviz-tooltip-divider' | 'dataviz-track' | 'dataviz-trend-down' | 'dataviz-trend-down-text' | 'dataviz-trend-flat' | 'dataviz-trend-up' | 'dataviz-trend-up-text' | 'dataviz-value' | 'fg-danger' | 'fg-default' | 'fg-disabled' | 'fg-info' | 'fg-inverse' | 'fg-metric-primary' | 'fg-muted' | 'fg-placeholder' | 'fg-primary' | 'fg-secondary' | 'fg-success' | 'fg-warning' | 'info-50' | 'info-100' | 'info-200' | 'info-300' | 'info-400' | 'info-500' | 'info-600' | 'info-700' | 'info-800' | 'info-900' | 'info-950' | 'neutral-50' | 'neutral-100' | 'neutral-200' | 'neutral-300' | 'neutral-400' | 'neutral-500' | 'neutral-600' | 'neutral-700' | 'neutral-800' | 'neutral-900' | 'neutral-950' | 'on-danger' | 'on-info' | 'on-neutral' | 'on-primary' | 'on-secondary' | 'on-status' | 'on-success' | 'on-warning' | 'primary-50' | 'primary-100' | 'primary-200' | 'primary-300' | 'primary-400' | 'primary-500' | 'primary-600' | 'primary-700' | 'primary-800' | 'primary-900' | 'primary-950' | 'raw-gray-shadow' | 'raw-green-50' | 'raw-mint-50' | 'raw-red-soft' | 'secondary-50' | 'secondary-100' | 'secondary-200' | 'secondary-300' | 'secondary-400' | 'secondary-500' | 'secondary-600' | 'secondary-700' | 'secondary-800' | 'secondary-900' | 'secondary-950' | 'success-50' | 'success-100' | 'success-200' | 'success-300' | 'success-400' | 'success-500' | 'success-600' | 'success-700' | 'success-800' | 'success-900' | 'success-950' | 'warning-50' | 'warning-100' | 'warning-200' | 'warning-300' | 'warning-400' | 'warning-500' | 'warning-600' | 'warning-700' | 'warning-800' | 'warning-900' | 'warning-950' | 'white';
export type FontFamilyToken = 'mono' | 'sans';
export type FontWeightToken = 'bold' | 'medium' | 'regular' | 'semibold';
export type DimensionToken = '2xl' | '3xl' | '4xl' | 'full' | 'lg' | 'md' | 'none' | 'sm' | 'xl' | 'xs' | '0' | '1' | '2' | '2-5' | '3' | '4' | '5' | '6' | '8' | '10' | '12' | '16' | '20' | '24' | 'gutter';
export type ShadowToken = 'card' | 'card-accent' | 'card-strong' | 'chip' | 'drawer' | 'drop' | 'dropdown' | 'halo' | 'modal' | 'popover' | 'subtle';
export type TypographyToken = 'body' | 'body-lg' | 'body-lg-medium' | 'body-medium' | 'body-sm' | 'body-sm-strong' | 'body-strong' | 'caption' | 'caption-sm' | 'caption-strong' | 'display' | 'heading-1' | 'heading-2' | 'heading-3' | 'heading-4' | 'label' | 'label-sm' | 'micro' | 'micro-strong' | 'title';
export type NumberToken = 'base' | 'dropdown' | 'modal' | 'overlay' | 'sticky' | 'sticky-content' | 'toast' | 'tooltip';
